<mat-toolbar class="no-background">
  <span>出金依頼の作成</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/withdrawal">
    <mat-icon>arrow_back</mat-icon>作成せずに戻る
  </a>
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data">

  <pre>このフォームへの入力と同時に申込書類のアップロードが必要となります。
お申し込み書類は紛失されないようお願いします。
お申し込み内容の変更・取消が必要な場合は、作成後に確認できる詳細画面からお願いします。
（但し、事務処理の進捗状況によっては、変更・取消を承れない場合もございます。）</pre>
<br>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>出資口座番号（出金元・50文字まで）</mat-label>
    <input matInput formControlName="acc" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('acc')?.hasError('maxlength') && form.get('acc')?.touched" class="inline-error">
        口座番号は50文字以内で入力してください　
      </span>
      {{ form.get('acc')?.value?.length || 0 }}/50
    </mat-hint>
    <pre>出資口座番号をご記入ください。複数ある場合はカンマ区切りでご記入ください。
（例）AA0123-0,BB3456-1,XX9988-9</pre>
  </mat-form-field>

  <div class="border-mat-radio">
    <label class="block mb-2 font-medium">ご出金方法 *</label>
    <mat-radio-group formControlName="method">
      <mat-radio-button class="block" value="全額出金">全額出金（解約）</mat-radio-button>
      <mat-radio-button class="block" value="一部出金">一部出金（残額は運用継続）</mat-radio-button>
    </mat-radio-group>

    <!-- バリデーション表示 -->
    <div class="text-sm text-red-600 mt-1" *ngIf="form.get('method')?.invalid && (form.get('method')?.dirty || form.get('method')?.touched)">
      ご出金方法は必須です。
    </div>
  </div>

  <mat-form-field appearance="outline" class="full-width" *ngIf="form.get('method')?.value === '一部出金'">
    <mat-label>一部出金の出金額</mat-label>
    <input matInput type="number" formControlName="amount">
    <mat-hint align="end">
      <span *ngIf="form.get('method')?.value === '一部出金' && form.get('amount')?.touched && form.get('amount')?.invalid" class="inline-error">
        一部出金の出金額を入力してください　
      </span>
    </mat-hint>
  </mat-form-field>

  <input type="file" #fileInput hidden multiple (change)="onFileChange($event)"/>

  <pre>ご解約出金申込書類のアップロード *

ご解約出金のお申込書の記入方法を必ずご確認の上、書類のご記入をお願いします。
<a href="https://fxwiz.info/documents/Withdrawal.pdf" target="_blank">お申込書はこちらからダウンロードできます。</a>
<a href="https://fxwiz.info/documents/sample-shukkin.png" target="_blank">お申込書の記入方法はこちらからご覧いただけます。</a></pre>

  <div
    class="drop-zone"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <p>ここにファイルをドロップまたは</p>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
    <p></p>
    <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

    <div *ngIf="selectedFiles.length > 0" class="mt-2">
      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>
    </div>

  </div>

  <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
    {{ form.get('files')?.getError('maxFileSize')?.message }}
  </mat-error>

  <pre>出金先銀行口座情報のご入力をお願いします。

送金通貨は運用通貨となります。両替（例えばJPYをUSDに両替など）は基本的に対応しておりません。
お客様都合による複数口座への送金などの場合は別途手数料がかかります。

※銀行情報に入力ミスがある場合は出金出来ない場合があります。十分にご確認ください。</pre>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>送金先銀行名（50文字まで）</mat-label>
    <input matInput formControlName="bank_name" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('bank_name')?.invalid && form.get('bank_name')?.touched" class="inline-error">
        送金先銀行名は必須です　
      </span>
      <span *ngIf="form.get('bank_name')?.hasError('maxlength') && form.get('bank_name')?.touched" class="inline-error">
        送金先銀行名は50文字以内で入力してください　
      </span>
      {{ form.get('bank_name')?.value?.length || 0 }}/50
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>本店・支店名（50文字まで）</mat-label>
    <input matInput formControlName="bank_branch" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('bank_branch')?.invalid && form.get('bank_branch')?.touched" class="inline-error">
        本店・支店名は必須です　
      </span>
      <span *ngIf="form.get('bank_branch')?.hasError('maxlength') && form.get('bank_branch')?.touched" class="inline-error">
        本店・支店名は50文字以内で入力してください　
      </span>
      {{ form.get('bank_branch')?.value?.length || 0 }}/50
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>本店・支店名番号（50文字まで）</mat-label>
    <input matInput formControlName="branch_number" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('branch_number')?.invalid && form.get('branch_number')?.touched" class="inline-error">
        本店・支店名番号は必須です　
      </span>
      <span *ngIf="form.get('branch_number')?.hasError('maxlength') && form.get('branch_number')?.touched" class="inline-error">
        本店・支店名番号は50文字以内で入力してください　
      </span>
      {{ form.get('branch_number')?.value?.length || 0 }}/50
    </mat-hint>
  </mat-form-field>

  <div class="border-mat-radio">
    <label class="block mb-2 font-medium">口座種別 *</label>
    <mat-radio-group formControlName="acc_type">
      <mat-radio-button class="block" value="普通預金">普通預金</mat-radio-button>
      <mat-radio-button class="block" value="当座預金">当座預金</mat-radio-button>
    </mat-radio-group>

    <!-- バリデーション表示 -->
    <div class="text-sm text-red-600 mt-1" *ngIf="form.get('acc_type')?.invalid && (form.get('acc_type')?.dirty || form.get('acc_type')?.touched)">
      預金種別は必須です。
    </div>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>口座番号（50文字まで）</mat-label>
    <input matInput formControlName="acc_number" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('acc_number')?.invalid && form.get('acc_number')?.touched" class="inline-error">
        口座番号は必須です　
      </span>
      <span *ngIf="form.get('acc_number')?.hasError('maxlength') && form.get('acc_number')?.touched" class="inline-error">
        口座番号は50文字以内で入力してください　
      </span>
      {{ form.get('acc_number')?.value?.length || 0 }}/50
    </mat-hint>
  </mat-form-field>

  <div class="border-mat-radio">
    <label class="block mb-2 font-medium">口座名義種別 *</label>
    <mat-radio-group formControlName="holder_type">
      <mat-radio-button class="block" value="ご契約者様名と同じ">ご契約者様名と同じ</mat-radio-button>
      <mat-radio-button class="block" value="共同名義の方の口座">共同名義の方の口座</mat-radio-button>
      <mat-radio-button class="block" value="法人口座">法人口座</mat-radio-button>
    </mat-radio-group>
    <pre>送金先はご契約者様宛か、もしくは共同名義人宛のどちらかとなります。
それ以外の口座名義人への送金は対応しておりません。</pre>

<!-- バリデーション表示 -->
    <div class="text-sm text-red-600 mt-1" *ngIf="form.get('holder_type')?.invalid && (form.get('holder_type')?.dirty || form.get('holder_type')?.touched)">
      口座名義種別は必須です。
    </div>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>海外銀行の場合（400文字まで）</mat-label>
    <textarea matInput formControlName="overseas" rows="3"></textarea>
    <mat-hint align="end">
      <span *ngIf="form.get('overseas')?.hasError('maxlength') && form.get('overseas')?.touched" class="inline-error">
        海外銀行の場合は400文字以内で入力してください　
      </span>
      {{ form.get('overseas')?.value?.length || 0 }}/400
    </mat-hint>
    <pre>送金先が海外銀行の場合は以下の入力欄に以下の情報を　【半角英数字で】　ご記入下さい。
銀行名、銀行住所、口座番号、口座名義、口座名義人住所、SWIFT、Routing No（必要な場合のみ）</pre>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>補足（400文字まで・補足がござましたらこちらからどうぞ）</mat-label>
    <textarea matInput formControlName="body" rows="6"></textarea>
    <mat-hint align="end">
      <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
        補足は400文字以内で入力してください　
      </span>
      {{ form.get('body')?.value?.length || 0 }}/400
    </mat-hint>
  </mat-form-field>

  <pre>お申し込みに対する当社の対応は、平日営業時間帯での対応となります。
お申込みは毎月20日で締め切られます。21日のお申込みは翌月お取り扱い分となります。</pre>

  <div style="text-align: right;">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      出金依頼を登録
    </button>
  </div>

</form>
